import { Controller } from "@hotwired/stimulus";

// Live countdown for the anonymous demo banner. Ticks the "self-destructs in …"
// label down each minute; when it reaches zero it swaps in an expiry notice.
export default class extends Controller {
  static targets = ["output"];
  static values = { remaining: Number };

  connect() {
    if (!this.hasOutputTarget || !this.remainingValue) return;
    this.render();
    this.timer = setInterval(() => this.tick(), 1000);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }

  tick() {
    this.remainingValue -= 1;
    if (this.remainingValue <= 0) {
      this.remainingValue = 0;
      clearInterval(this.timer);
      this.outputTarget.textContent =
        "This demo has expired — start a free trial to keep exploring.";
      return;
    }
    // Re-render roughly once a minute to keep it cheap.
    if (this.remainingValue % 30 === 0) this.render();
  }

  render() {
    this.outputTarget.textContent = `It self-destructs in ${this.humanize(
      this.remainingValue
    )}.`;
  }

  humanize(seconds) {
    const d = Math.floor(seconds / 86400);
    const h = Math.floor((seconds % 86400) / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    if (d > 0) return `${d} day${d === 1 ? "" : "s"}, ${h} hr`;
    if (h > 0) return `${h} hr, ${m} min`;
    return `${m} min`;
  }
}
